<template>
  <div class="flex flex-row w-full gap-2 sticky top-0 bg-white z-10 p-2">
    <div class="pill__SearchInput InputGroupFocus flex-grow w-full">
      <input
        class="form-control !py-1"
        type="text"
        :placeholder="$t('Search')"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
      />
      <aw-icon 
        v-if="!modelValue"
        icon="search" 
      />
      <button 
        v-if="modelValue"
        class="SearchInput__CloseIcon"
        @click.stop.prevent="eraseSearch()"
      >
        <aw-icon icon="close"/>
      </button>
    </div>
    <aw-dropdown placement="bottom-start" :offset="[0, 2]">
      <template v-slot:btn="{ open }">
        <button 
          class="pill__Button pill__Button-sm w-24"
          @click="open"
        >
          {{ $t('Sort') }}
          <aw-icon icon="sort-up-down" class="h-5 w-5 -mr-2" />
        </button>
      </template>
      <template v-slot:dropdown="{ opened, dropdown, close }">
        <ul
          class="Dropdown Dropdown--Short flex flex-col gap-y-2 rounded-md shadow-md bg-white text-sm p-2 relative z-10"
          v-show="opened"
          :ref="dropdown"
        >
          <li 
            v-for="(item, i) in sortFilters"
            :key="i"
            @click="sort(item.action, close)"
            class="cursor-pointer hover:bg-gray-100"
            :class="{ 'text-bc-blue': item.action === currentSortOrder }"
          >
            <aw-icon
              :icon="item.action === currentSortOrder && currentSortDir === 'asc' ? 'chevron-up' : 'chevron-down'"
              class="w-6 h-6"
            />
            {{ $t(item.text) }}
          </li>
        </ul>
      </template>
    </aw-dropdown>
  </div>
</template>

<script>
export default {
  emits: [
    'update:modelValue', 
    'update:sortOrder', 
  ],
  props: {
    modelValue: String,
    showSearch: {
      type: Boolean,
      default: true,
    },
    currentSortDir: String,
    currentSortOrder: String,
    sortFilters: Array
  },
  methods: {
    eraseSearch() {
      this.$emit('update:modelValue', '')
    },
    sort(sortOrder, close) {
      this.$emit('update:sortOrder', sortOrder)
      close()
    }
  },
}
</script>

<style lang="scss" scoped></style>
